import { createAction } from "@reduxjs/toolkit";
import { Notification } from '../../../types/NotificationSlice';

export const addNotification = createAction<Notification>('notification/addNotification');
export const removeNotification = createAction<String>('notification/removeNotification');
export const clearNotification = createAction('notification/clearNotification');
